import { numberWithoutComma } from "../../pages/balance/component/VIDrawerDebt.Main";

export const LifeInsurancePDF = (insuranceData) => {
  return (
    Number(insuranceData?.asset_insurance_private || 0) +
    Number(insuranceData?.sum_asset_current || 0) -
    (Number(insuranceData?.sum_family || 0) +
      Number(insuranceData.sum_family_debt || 0) +
      Number(insuranceData.sum_insurance_education || 0))
  );
};

export const LifeInsuranceBalance = (balanceData) => {
  const insuranceData = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return Number(num.allowance_peryear || 0) + acc;
    }, 0);
  return insuranceData;
};

export const DisableInsurancePDF = (insuranceData) => {
  return (
    insuranceData.sum_disabled_have_to_money -
    (insuranceData.sum_disabled_insurance_current +
      insuranceData?.sum_disabled_social_security_fund) -
    insuranceData.sum_disabled_asset_current
  );
};

export const DisableCheckBalance = (balanceData) => {
  const insuranceData = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return (
        acc +
        Number(num?.more_details?.aia_mutiplay_ci_more || 0) +
        Number(num?.more_details?.aia_total_care_more || 0) +
        Number(num?.more_details?.compensation_aia_ci_plus || 0) +
        Number(num?.more_details?.compensation_aia_ci_plus_gold || 0) +
        Number(num?.more_details?.compensation_aia_ci_topup || 0) +
        Number(num?.more_details?.compensation_aia_procare || 0) +
        Number(num?.more_details?.compensation_aia_supercare || 0) +
        Number(num?.more_details?.compensation_ecir || 0) +
        Number(num?.more_details?.compensation_mutiple_care_ci || 0) +
        Number(num?.more_details?.contract_tpd || 0) +
        Number(num?.more_details?.critical_illness_insurance_yearly_ci || 0)
      );
    }, 0);
  return insuranceData;
};

export const HealthCheckBalance = (balanceData) => {
  const insuranceData = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return (
        acc +
        Number(num?.more_details?.daily_compensation_for_treatment || 0) +
        Number(
          num?.more_details?.daily_compensation_for_treatment_special || 0
        ) +
        Number(num?.more_details?.hospital_treatment_surgery || 0) +
        Number(
          num?.more_details?.hospital_treatment_surgery_lump_sum_payment || 0
        )
      );
    }, 0);
  return insuranceData;
};

export const HealthCheckPDF = (balanceData) => {
  const insuranceData = balanceData?.expenses_fixed_list?.find(
    (item) => item?.options_expenses_fixed === "expenses_insuarant_life"
  )?.expenses_insuarant_lifes;

  const treatmentSurgery = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return (
        acc +
        Number(
          numberWithoutComma(num?.more_details?.hospital_treatment_surgery) || 0
        )
      );
    }, 0);

  const treatmentSurgeryLumpSum = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return (
        acc +
        Number(
          numberWithoutComma(
            num?.more_details?.hospital_treatment_surgery_lump_sum_payment
          ) || 0
        )
      );
    }, 0);

  const compensationtreatment = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return (
        acc + Number(num?.more_details?.daily_compensation_for_treatment || 0)
      );
    }, 0);

  const compensationtreatmentSpacial = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return (
        acc +
        Number(num?.more_details?.daily_compensation_for_treatment_special || 0)
      );
    }, 0);

  const contract_tpd = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return acc + Number(num?.more_details?.contract_tpd || 0);
    }, 0);

  const aia_mutiplay_ci_more = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return acc + Number(num?.more_details?.aia_mutiplay_ci_more || 0);
    }, 0);

  const aia_total_care_more = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return acc + Number(num?.more_details?.aia_total_care_more || 0);
    }, 0);

  const compensation_ecir = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return acc + Number(num?.more_details?.compensation_ecir || 0);
    }, 0);

  const compensation_aia_supercare = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return acc + Number(num?.more_details?.compensation_aia_supercare || 0);
    }, 0);

  const compensation_aia_procare = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return acc + Number(num?.more_details?.compensation_aia_procare || 0);
    }, 0);

  const compensation_aia_ci_plus_gold = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return (
        acc + Number(num?.more_details?.compensation_aia_ci_plus_gold || 0)
      );
    }, 0);

  const compensation_aia_ci_plus = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return acc + Number(num?.more_details?.compensation_aia_ci_plus || 0);
    }, 0);

  const compensation_aia_ci_topup = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return acc + Number(num?.more_details?.compensation_aia_ci_topup || 0);
    }, 0);

  const compensation_mutiple_care_ci = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return acc + Number(num?.more_details?.compensation_mutiple_care_ci || 0);
    }, 0);

  const critical_illness_insurance_yearly_ci = balanceData?.expenses_fixed_list
    ?.find((item) => item?.options_expenses_fixed === "expenses_insuarant_life")
    ?.expenses_insuarant_lifes?.reduce((acc, num) => {
      return (
        acc +
        Number(num?.more_details?.critical_illness_insurance_yearly_ci || 0)
      );
    }, 0);
  return {
    treatmentSurgery,
    treatmentSurgeryLumpSum,
    compensationtreatment,
    compensationtreatmentSpacial,
    contract_tpd,
    aia_mutiplay_ci_more,
    aia_total_care_more,
    compensation_ecir,
    compensation_aia_supercare,
    compensation_aia_procare,
    compensation_aia_ci_plus_gold,
    compensation_aia_ci_plus,
    compensation_aia_ci_topup,
    compensation_mutiple_care_ci,
    critical_illness_insurance_yearly_ci,
  };
};

// export const DisableInsurance = (balanceData) => {

// }
